var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-a-4"},_vm._l((_vm.tickets),function(ticket,index){return _c('ticket-item',{key:index,attrs:{"ticket":ticket,"add":true,"type":_vm.type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }